import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface ScenarioMasterState {
  data: any[] | null;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allScenarioMasterList: any[];
  religions: any[];
}

const initialState: ScenarioMasterState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allScenarioMasterList: [],
  religions: [],

};

export const scenarioMasterSlice = createSlice({
  name: 'scenarioMaster',
  initialState,
  reducers: {
    setScenarioMasters: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setScenarioMastersBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllScenarioMasters: (state, action) => {
      state.allScenarioMasterList = action.payload.data;
    },
      setReligions: (state, action) => {
          state.religions = action.payload.data;
        },
    resetScenarioMaster: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export const {
  setScenarioMasters,
  setScenarioMastersBySearch,
  setAllScenarioMasters,
   setReligions,
  resetScenarioMaster,
} = scenarioMasterSlice.actions;

export const getScenarioMasterData = (state: RootState) => state.scenarioMaster.data;
export const getAllScenarioMasterList = (state: RootState) => state.scenarioMaster.allScenarioMasterList;
export const getScenarioMasterTotalRecords = (state: RootState) => state.scenarioMaster.totalRecords;
export const getScenarioMasterDataBySearch = (state: RootState) => state.scenarioMaster.data;
export const getReligionsWithAll = (state: RootState) => [
  { id: 0, label: "All" },
  ...(state.scenarioMaster.religions || []),
];
export default scenarioMasterSlice.reducer;
